import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  setItem(
    key: string,
    value: string,
  ): void {
    localStorage.setItem(
      key,
      value,
    );
  }
  removeItem(
    key: string,
  ): void {
    localStorage.removeItem(
      key,
    );
  }
  getItem(
    key: string | undefined,
  ): string | null {
    if (!key) {
      return null;
    }
    const value: string | null = localStorage.getItem(
      key,
    );
    return value;
  }
  getNumberList(
    key: string,
  ): number[] {
    let values: number[] = [];
    const valueStr: string | null = this.getItem(key);
    if (
      valueStr
    ) {
      values = JSON.parse(valueStr);
    }
    return values;
  }
  getStringList(
    key: string,
  ): string[] {
    let values: string[] = [];
    const valueStr: string | null = this.getItem(key);
    if (
      valueStr
    ) {
      values = JSON.parse(valueStr);
    }
    return values;
  }
  getString(
    key: string,
  ): string | undefined {
    const valueStr: string | null = this.getItem(key);
    return valueStr ?? undefined;
  }
  getNumber(
    key: string,
  ): number | undefined {
    let value: number | undefined;
    const valueStr: string | null = this.getItem(key);
    if (
      valueStr
    ) {
      value = Number.parseInt(valueStr, 10);
    }
    return value;
  }
}
